import React from 'react';
import { cn } from './lib/utils';

/* Native checkbox wrapped in a label, matching the legacy
   `~co/common/form` Checkbox layout (grid row, --padding-small gap).
   `accent-accent` themes the native control with the brand indigo. */
export function Checkbox({ className, children, hidden, ...props }) {
  return (
    <label
      hidden={hidden}
      className={cn('ui-checkbox', className)}
    >
      <input
        type='checkbox'
        tabIndex='0'
        className='size-4 accent-accent'
        {...props}
      />
      {children}
    </label>
  );
}
